module.exports = __webpack_public_path__ + "static/media/LINK-ETH.e37098f7.png";